import __request__ from "routing/request";
export function searchKeyword(query, keyword, limit, offset, filter, fields, streams, sort, decorate = true, requestOptions) {
  return __request__("GET", "/search/universal/keyword", null, { "query": query, "keyword": keyword, "limit": limit, "offset": offset, "filter": filter, "fields": fields, "streams": streams, "sort": sort, "decorate": decorate }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchKeywordChunked(query, keyword, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/keyword", null, { "query": query, "keyword": keyword, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function exportSearchKeywordChunked(query, keyword, fields, limit, offset, batch_size = 500, filter, streams, requestOptions) {
  return __request__("GET", "/search/universal/keyword/export", null, { "query": query, "keyword": keyword, "limit": limit, "offset": offset, "batch_size": batch_size, "filter": filter, "streams": streams, "fields": fields }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
